<div class="bo-dialog">


<header class="bo-dialog__head"><span class="bo-dialog__icon"><i class="bi bi-crop" aria-hidden="true"></i></span><div class="bo-dialog__heading"><h2 id="product-crop-title">{{ 'cropper-modal-title' | translate }}</h2><p id="product-crop-description">{{ 'ml_type_photo' | translate }}<span *ngIf="imageConfig.width && imageConfig.height"> · {{ imageConfig.width }} × {{ imageConfig.height }} px</span></p></div><button type="button" class="bo-dialog__close" [attr.aria-label]="'ac_close' | translate" (click)="activeModal.dismiss()"><i class="bi bi-x-lg" aria-hidden="true"></i></button></header>

<div class="bo-dialog__body bo-product-crop-body">
  <div *ngIf="isImageLoading" class="cropper-spinner-overlay">
    <div class="spinner-border text-secondary" role="status">
      <span class="visually-hidden"></span>
    </div>
  </div>
  <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true"
    [aspectRatio]="getAspectRatioValue()" [resizeToWidth]="imageConfig.width" [onlyScaleDown]="true" format="png"
    (imageLoaded)="imageLoaded()" (loadImageFailed)="loadImageFailed()"
    [style.visibility]="isImageLoading ? 'hidden' : 'visible'" (imageCropped)="imageCropped($event)"
    style="max-height: 100%; width: 100%;"></image-cropper>

  <div *ngIf="croppedImage" class="text-center mt-3">
    <h6>Previsualización</h6>
    <img [src]="croppedImage" class="img-thumbnail" style="width: 100px; height: 100px; object-fit: cover;">
  </div>
</div>

<div class="bo-dialog__foot">
  <button type="button" class="bo-dialog__button" (click)="activeModal.dismiss('Cancelado')">
    {{ "ac_cancel" | translate }}
  </button>
  <button type="button" [disabled]="!imageFile || isImageLoading" class="bo-dialog__button bo-dialog__button--primary" (click)="activeModal.close(imageFile)">
    <i class="bi bi-check-lg me-1"></i>
    {{ "auth_accept" | translate }}
  </button>
</div>
</div>
